import { inject, injectable } from "tsyringe";
import { DataWarehouseParams, TrackingParams } from "@identity/services";
import { DataWarehouseSender } from "./data-warehouse-sender";
import { dataWarehouseUrls } from "./data-warehouse-urls";
import { WINDOW } from "@identity/symbols";
import { Geo, WikiConfig } from "@identity/utils";

export interface ConsentsEventParams {
  ga_category: ModalCategory;
  ga_action: ModalAction;
  ga_label: ModalLabel;
}

export type ModalCategory =
  | "gdpr-modal"
  | "gdpr-modal-1t"
  | "ccpa-modal"
  | "ccpa-modal-1t";
export type ModalAction = "impression" | "click";
export type ModalLabel =
  | "accept"
  | "reject"
  | "modal-view"
  | "impression"
  | "gpc"
  | "close";

@injectable()
export class ConsentsEventSender {
  constructor(
    @inject(WINDOW) private readonly window: Window,
    @inject(Geo) private readonly geo: Geo,
    @inject(WikiConfig) private readonly wikiConfig: WikiConfig,
    @inject(DataWarehouseSender) private readonly sender: DataWarehouseSender,
  ) {}

  send(payload: ConsentsEventParams): void {
    const params = {
      ...payload,
      ...this.getTrackingParams(),
    } as DataWarehouseParams;

    this.sender.sendEvent(params, dataWarehouseUrls.consents);
  }

  private getTrackingParams(): TrackingParams {
    return {
      lang_code: this.getLanguageCode() || "unknown",
      detected_geo: (this.geo.getCountryCode() || "").toUpperCase(),
      detected_region: (this.geo.getRegionCode() || "").toUpperCase(),
      beacon: this.window.fandomContext?.tracking?.beaconId,
      pv_unique_id: this.window.fandomContext?.tracking?.pvUID,
    };
  }

  private getLanguageCode(): string {
    return (
      this.wikiConfig.get("wgUserLanguage") ||
      this.window?.navigator?.language?.toLowerCase().substring(0, 2)
    );
  }
}
